module.exports = __webpack_public_path__ + "img/image (1).d39fb671.png";